import ModelProxy from "../model-proxy"
import MyWorkEvent from "./my-work/event"
import {ITEM_TYPE_EVENT} from "../../gd/const/item"
import ModelEntity from "../model-entity"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import {EventType} from "../../gd/const/event"
import {momentRange} from "../../gd/convert/moment-range"
import {eventCalculateDisplayEndDate, eventCalculateDisplayStartDate} from "./functions/display-dates"
import {SystemStatus} from "../../gd/const/system-status"
import EntityCollection from "../entities-collection/entities-collection"
import {EventAccessControl} from "./access-control/access-control"
import {calculateCalendarDuration} from "../../gd/manager/start-end-duration/calculate-calendar-duration"
import {calculateWorkdayDuration} from "../../gd/manager/start-end-duration/calculate-workday-duration"
import eventSetCalendarDuration from "./actions/set-calendar-duration"
import WorkScheduleProto from "../../gd/manager/work-schedule/work-schedule-proto"
import eventSetWorkdayDuration from "./actions/set-workday-duration"
import eventUpdateStartDate, {UpdateDateOptions} from "./actions/update-start-date"
import eventUpdateEndDate from "./actions/update-end-date"
import eventUpdateStartEndDate from "./actions/update-start-end"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
import {BUS_EVENT_CHANGE} from "./@bus";

const debug = false
// const debug = "EventBaseModel"

export default class Event extends ModelEntity {

    public eventType          : EventType
    public isAccomplished     : boolean

    public name               : string
    public notes              : string
    private _startDate        : Moment | null
    private _endDate          : Moment | null
    public dateCreated        : Moment | null

    public createdByUserId    : ID
    public userId             : ID | null
    public projectId          : ID | null
    public companyId          : ID
    public assignedToUserId   : ID | null

    // public sortPosition         : number | null | undefined // should be renamed to viewSortPosition later

    // filled with initFromSession method
    public user               : any
    public project            : any
    public company            : any
    public assignedToUser     : any

    public task                 : any
    public meeting              : any

    public recurrencyId         : ID | null

    public _myWorkProps?        : MyWorkEvent

    // isTemplate, isDeleted and momentCreated parameters are passed on 'event' 'move' session event (usage not found)
    public isTemplate           : boolean
    public isDeleted            : boolean
    public momentCreated?       : Moment

    // Gantt
    // public duration?            : DurationDays // claculated somewhere esle just stored here

    // Dependencies
    // public predecessors?        : any[]
    // public successors?          : any[]
    public predecessors         : EntityCollection = new EntityCollection([])
    public successors           : EntityCollection = new EntityCollection([])



    public displayStartDate?    : Moment
    public displayEndDate?      : Moment

    public _durationWorkdays?    : number | null // undefined means calculation is required
    public _durationCalendar?   : number | null // undefined means calculation is required

    public customFieldsData     : any = {} // should present as custom fields refer to this parameter

    constructor(data:any, options={}) {
        super(data['id'], ITEM_TYPE_EVENT);

        // this.itemType           = ITEM_TYPE_EVENT  // gd.const.itemType used in resource collections
        // this.id                 = data['id']
        // this.rid                = 'e-'+data['id']

        this.eventType          = data['eventType'] || data['type'] // type sent atleast in gantt... can it be 0 ?
        this.isAccomplished     = data['isAccomplished']

        this.name               = data['name']
        this.notes              = data['notes']
        this._startDate         = data['startDate'] ? DatetimeUtils.dateToMoment(data['startDate']) : null
        this._endDate           = data['endDate'] ? DatetimeUtils.dateToMoment(data['endDate']) : data['startDate'] ? DatetimeUtils.dateToMoment(data['startDate']) : null
        this.dateCreated        = data['dateCreated'] ? DatetimeUtils.datetimeToMoment(data['dateCreated']) as Moment : null

        this.createdByUserId    = data['createdByUserId']
        this.userId             = data['userId']            ? data['userId']            : data['user']              ? data['user']['id']            : null
        this.projectId          = data['projectId']         ? data['projectId']         : data['project']           ? data['project']['id']         : null
        this.companyId          = gd.companyId // this property is redundant
        this.assignedToUserId   = data['assignedToUserId']  ? data['assignedToUserId']  : data['assignedToUser']    ? data['assignedToUser']['id']  : null

        // filled with initFromSession method
        this.user               = data['user']
        this.project            = data['project']
        this.company            = gd.company // this property is redundant
        this.assignedToUser     = data['assignedToUser']

        this.task               = data['task']
        this.meeting            = data['meeting']

        this.recurrencyId       = data['recurrencyId']

        /*if (_.get(options,'initMyWork')) {
            this.myWorkProps = new MyWorkEvent(this)
        }*/

        this.displayStartDate   = data['displayStartDate'] ? DatetimeUtils.dateToMoment(data['displayStartDate']) as Moment : eventCalculateDisplayStartDate(this)
        this.displayEndDate     = data['displayEndDate'] ? DatetimeUtils.dateToMoment(data['displayEndDate']) as Moment : eventCalculateDisplayEndDate(this)

        this.isTemplate         = data['isTemplate']
        this.isDeleted          = data['isDeleted']
        this.momentCreated      = data['momentCreated'] ? DatetimeUtils.dateToMoment(data['momentCreated']) as Moment : undefined

        const useProxy = _.get(options, 'useProxy', true)
        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    // is required for sorting to have the same property name as Task
    get title() {
        return this.name
    }

    get templateParent(){
        return this.projectId
    }

    get acl():EventAccessControl {
        return new EventAccessControl(this)
    }

    quickSearch(quickSearchValueNormalized:string):boolean {
        return this.name.toLowerCase().includes(quickSearchValueNormalized)
    }

    setCustomFieldValue(customFieldId:ID, value:any) {
        console.error("#948420213038 impossibnle case")

    }



    get startDate() { return this._startDate }
    set startDate(startDate:Moment|null) {
        this._startDate = startDate
        this.updatedFields.add('startDate')
        this.onFieldChange('startDate', startDate)
    }

    get endDate() { return this._endDate }
    set endDate(endDate: Moment|null) {
        this._endDate = endDate
        this.updatedFields.add('endDate')
        this.onFieldChange('endDate', endDate)
    }

    // DURATION

    get workSchedule():WorkScheduleProto {
        return gd.workSchedule.getCompanyWorkSchedule()
    }

    get durationCalendar(): number | null {
        if (this._durationCalendar === undefined) this._durationCalendar = calculateCalendarDuration(this.startDate, this.endDate)
        return this._durationCalendar
    }
    set durationCalendar(value: number | null) {
        eventSetCalendarDuration(this, value)
    }

    get durationWorkdays(): number | null {
        if (this._durationWorkdays === undefined) this._durationWorkdays = calculateWorkdayDuration(this.startDate, this.endDate)
        return this._durationWorkdays
    }

    set durationWorkdays(value: number | null) {
        eventSetWorkdayDuration(this, value)
    }





    // for compatibility if necessary
    get type() {
        return this.eventType
    }

    get scope() {
        if (this.type>0 && this.type<10)    return 'project';
        if (this.type>=10 && this.type<20)  return 'organization';
        if (this.type>=20 && this.type<30)  return 'personal';
        if (this.type>=30)                  return 'task';
        if (this.type>=40)                  return 'meeting';
    }

    get isSingleDayType() {
        return gd.const.event.singleDayTypes.includes(this.eventType)
    }

    get isPastdue() {

        if (!this.canBePastdue) return false

        if (!this.startDate) return false

        return DatetimeUtils.isBeforeToday(this.startDate)
    }

    get pastdue() {
        if (!this.startDate) return false

        return this.startDate.isBefore(moment(),'days');
    }

    get isProject() {
        return (this.type>0 && this.type<10);
    }

    get isOrganization() {
        return (this.type>=10 && this.type<20);
    }

    get isPersonal() {
        return (this.type>=20 && this.type<30);
    }

    get canBePastdue() {
        // events can be passed due if
        // Project Deadline, Project milestone, Task Deadline
        const allowedEventType = new Set([
            gd.const.event.type.PROJECT_MILESTONE,
            gd.const.event.type.PROJECT_DEADLINE,
            gd.const.event.type.TASK_DEADLINE,
        ])

        return allowedEventType.has(this.eventType)
    }

    get canBeRecurrent() {

        const allowedEventType = new Set([
            gd.const.event.type.PROJECT_EVENT,
            gd.const.event.type.PROJECT_MILESTONE,
            gd.const.event.type.COMPANY_EVENT,
            gd.const.event.type.COMPANY_HOLIDAY,
        ])

        return allowedEventType.has(this.eventType)
    }

    get myWorkProps():MyWorkEvent {
        if (!this._myWorkProps) {
            this._myWorkProps = new MyWorkEvent(this)
        }

        return this._myWorkProps
    }

    initFromSession(){
        // if (this.companyId)         this.company        = gd.session.companies.get(this.companyId);
        if (this.projectId)         this.project        = gd.session.projects.get(this.projectId);
        if (this.userId)            this.user           = gd.session.users.get(this.userId);
        if (this.assignedToUserId)  this.assignedToUser = gd.session.users.get(this.assignedToUserId);
    }

    toFullCalendar(){
        return {
            id              : this.id,
            title           : this.name,
            allDay          : true,
            start           : this.startDate ? this.startDate.format('YYYY-MM-DD') : null,
            end             : this.endDate ? moment(this.endDate).add(1,'day').format('YYYY-MM-DD') : null,
            eventObject     : this,
            startEditable   : gd.ac.check.event.canEditEvent(this)
        }
    }

    /*** NEW METHODS ***/

    get startEnd() {
        if (this.startDate && this.endDate) return momentRange(this.startDate, this.endDate)
        return null
    }

    set startEnd(dateRange) {
        this.startDate  = dateRange?.start   ? dateRange.start   : null;
        this.endDate    = dateRange?.end     ? dateRange.end     : null;
    }

    updateStartDate(startDate:Moment|null, options:UpdateDateOptions={}) {
        eventUpdateStartDate(this, startDate, options)
        // this = Event WITHOUT proxy so we need manually update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    updateEndDate(endDate:Moment|null) {
        eventUpdateEndDate(this, endDate)
        // this = Event WITHOUT proxy so we need manually update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    updateStartEnd(startDate:Moment|null, endDate:Moment|null) {
        eventUpdateStartEndDate(this, startDate, endDate)

        // this = Event WITHOUT proxy so we need manually update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    _isSameValue(paramName:string, value:any) {
        // @ts-ignore
        if (Moment.isMoment(this[paramName])) {
            // console.log("isSameValue", DatetimeUtils.momentToDate(this[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day'))
            // @ts-ignore
            return DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day')
        } else {
            // @ts-ignore
            return _.isEqual(this[paramName],value)
        }
    }

    applyDelta(data:any) {

        debug && console.log(debug, "applyDelta()", data)

        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            // @ts-ignore
            debug && console.log(debug, "applyDelta key=", key, !this._isSameValue(key, value), this[key], value)

            if (!this._isSameValue(key, value)) {

                debug && console.log(".....set", key, "neValue", value)

                switch (key) {
                    case 'startDate':
                        this._startDate = DatetimeUtils.dateToMoment(value);
                        break

                    case 'endDate'  :
                        this._endDate   = DatetimeUtils.dateToMoment(value)
                        break

                    default         :
                        // @ts-ignore
                        this[key] = value
                }

                isChanged = true
            }
        });

        debug && console.log(debug, "....applyDelta isChanged", isChanged)

        return isChanged
    }

    toJSON(): JSONObject {
        let res: JSONObject = {}

        _.mapKeys(this, (value: any, key)=>{
            switch (key) {

                // ignored keys
                case 'company':
                case 'duration':
                case 'project':
                case 'user':
                case 'assignedToUser':
                    // Ignore
                    return

                case '_startDate'   :
                    res.startDate = value ? DatetimeUtils.momentToDate(value) : null
                    break

                case '_endDate'     :
                    res.endDate = value ? DatetimeUtils.momentToDate(value) : null
                    break

                case 'dateCreated'  :
                    res[key] = value ? DatetimeUtils.momentToUTCISODatetime(value) : null
                    break

                // causes circular toJSON if not empty
                case 'successors'   :
                case 'predecessors' :
                    res[key] = []
                    break

                default             :
                    res[key] = value && value.toJSON ? value.toJSON() : value
            }
        })

        return res
    }

    save() {
        const params = {}

        // name
        if (this.updatedFields.has('name')) {
            gd.api.Events.setName(this.id, this.name).done((response:any)=>{
                gd.bus.triggerEvent(BUS_EVENT_CHANGE, this, response);
            });
            this.updatedFields.delete('name');
        }

        // startEnd
        if (this.updatedFields.has('startEnd') || this.updatedFields.has('startDate') || this.updatedFields.has('endDate')) {
            gd.api.Events.setStartEnd(this.id, this.startDate, this.endDate).done((response:any)=>{
                gd.bus.triggerEvent(BUS_EVENT_CHANGE, this, response, 'event-dates');
            });
            this.updatedFields.delete('startEnd');
            this.updatedFields.delete('startDate');
        }

        // notes
        if (this.updatedFields.has('notes')) {
            gd.api.Events.setNotes(this.id, this.notes).done((response:any)=>{
                gd.bus.triggerEvent(BUS_EVENT_CHANGE, this, response);
            });
            this.updatedFields.delete('notes');
        }

        // isAccomplished
        if (this.updatedFields.has('isAccomplished')) {
            gd.api.Events.setAccomplished(this.id, this.isAccomplished).done((response:any)=>{
                gd.bus.triggerEvent(BUS_EVENT_CHANGE, this, response);
            });
            this.updatedFields.delete('isAccomplished');
        }

        // assignedToUserId
        if (this.updatedFields.has('assignedToUserId')) {
            gd.api.Events.assignTo(this.id, this.assignedToUserId!).done((response:any)=>{
                gd.bus.triggerEvent(BUS_EVENT_CHANGE, this, response, 'event-user');
            });
            this.updatedFields.delete('assignedToUserId');
        }

        // projectId
        if (this.updatedFields.has('projectId')) {
            gd.api.Events.setProjectId(this.id, this.projectId!).done((response:any)=>{
                gd.bus.triggerEvent(BUS_EVENT_CHANGE, this, response, 'event-user');
            });
            this.updatedFields.delete('projectId');
        }

        // this is for universal update
        this.updatedFields.forEach((fieldName) => {
            // @ts-ignore
            params[fieldName] = this[fieldName];
        })

        this.updatedFields.clear()

        // if (params && _.size(params)>0) gd.api.Event.update(this.id, params);
    }


    get iconClassName() {

        switch (this.eventType) {
            case gd.const.event.type.COMPANY_EVENT          : return "i5-organization"
            case gd.const.event.type.COMPANY_HOLIDAY        : return "i5-event-company-holiday"

            case gd.const.event.type.PERSONAL_PAID_VACATION : return "i5-event-personal-vacation"
            case gd.const.event.type.PERSONAL_TRAVEL        : return "i5-event-personal-travel"
            case gd.const.event.type.PERSONAL_SICK_LEAVE    : return "i5-event-personal-sick-leave"

            case gd.const.event.type.PROJECT_MILESTONE      : return "i5-milestone"
            case gd.const.event.type.PROJECT_DEADLINE       : return "i5-event-project-deadline"
            case EventType.PROJECT_EVENT                    : return "i5-event-project-event"

        }
    }

    // ItemModel METHODS

    get isClosed() {
        return !!this.isAccomplished
    }

    get systemStatus():SystemStatus {
        switch (this.eventType) {

            case gd.const.event.type.PROJECT_MILESTONE:
                if (this.isAccomplished) return SystemStatus.COMPLETED
                else return SystemStatus.IN_PROGRESS

            default:
                return SystemStatus.IN_PROGRESS
        }
    }

    get progress():number|null {
        // event has no progress :)
        return null
    }

    get tasksTotal():number {
        return 0
    }

    get tasksOpen():number {
        return 0
    }

    // // TS error prevention
    // get progressSubItems() { return {} }
    // set progressSubItems(value:any) {}

    // get progressAuto() { return {} }
    // set progressAuto(value:any) {}

    get statusId() { return null }

    // End Item Model Interface


    // Gantt
    setAssignedToUser(userId:ID) {
        this.assignedToUserId = userId
    }

    _calculateDisplayStartDate() {
        return eventCalculateDisplayStartDate(this)
    }

    _calculateDisplayEndDate() {
        return eventCalculateDisplayEndDate(this)
    }

    get isOpen() {
        return !this.isAccomplished
    }

    // used in gantt
    get datesForDependency() {
        return {
            start   : this.startDate,
            end     : this.endDate
        }
    }

    // END Gantt


    goTo() {
        gd.navigation.goToEvent(this.id)
    }


    onFieldChange(field:string, newValue:any) {

        // if (field==='progressSubItems') return

        // console.log(field, "changed")

        switch (field) {

            case 'startDate':
                this._durationCalendar      = undefined
                this._durationWorkdays      = undefined
                this.displayStartDate       = eventCalculateDisplayStartDate(this)
                break


            case 'endDate':
                this._durationCalendar      = undefined
                this._durationWorkdays      = undefined
                this.displayEndDate         = eventCalculateDisplayEndDate(this)
                return

            default:
                return
        }
    }

    validate():ErrorProto[] | null {

        const errors: any[] = []

        // name alwasy required
        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.event.name))

        // start date vsegda required
        if (!this.startDate) errors.push(new ErrorFieldRequired(gd.fields.event.startDate))


        switch (this.type) {
            case EventType.PROJECT_EVENT:
            case EventType.PROJECT_DEADLINE:
            case EventType.PROJECT_MILESTONE:
            case EventType.PROJECT_CREATED:
            case EventType.PROJECT_PAYMENT:

                // project events have project
                if (!this.projectId) {
                    errors.push(new ErrorFieldRequired(gd.fields.event.projectId))
                }
        }

        // End date not required for ???
        if (![EventType.PROJECT_MILESTONE].includes(this.type)) {
            if (!this.endDate) errors.push(new ErrorFieldRequired(gd.fields.event.endDate))
            if (!this.startEnd) errors.push(new ErrorFieldRequired(gd.fields.event.startEnd))
        }


        if (_.isEmpty(errors)) return null
        else return errors
    }


}
